import React from 'react';
import { formatTestId } from '../../../../utils/test-id/format-testid';
import { Image } from '../../Image/Image';
import { Icon } from '../Icon/Icon';
import styles from './NavLink.scss';
import classNames from 'classnames';

type NavLinkProps = {
  asAnchor?: boolean;
  isExtra?: boolean;
  label: string;
  url?: string;
  isExternal?: boolean;
  handleClick: () => void;
  shouldShowThumbnail: boolean;
  shouldShowIcon?: boolean;
  tab?: string;
  imageUrl: string;
  hierarchy?: string;
  testId?: string;
  tabIndex?: number;
};

export const NavLink = ({
  asAnchor = false,
  isExtra = false,
  label,
  url,
  isExternal,
  handleClick,
  shouldShowThumbnail,
  shouldShowIcon,
  tab,
  imageUrl,
  hierarchy,
  testId,
  tabIndex,
}: NavLinkProps) => {
  const getTestId =
    testId || formatTestId(label, tab === 'Money' ? 'services-' : 'nav-');
  const Wrapper = asAnchor ? 'a' : 'button';
  const anchorProps = {
    href: url,
    'data-hierarchy': hierarchy,
    target: isExternal ? '_blank' : undefined,
    rel: isExternal ? 'noreferrer' : undefined,
  };
  const buttonProps = {
    'aria-label': label.endsWith('*')
      ? `${label.replace('*', '')} selected lines only`
      : label,
  };

  return (
    <Wrapper
      onClick={handleClick}
      {...(asAnchor ? anchorProps : {})}
      {...(!asAnchor ? buttonProps : {})}
      tabIndex={tabIndex}
      data-testid={getTestId}
      className={classNames(styles.button, {
        [styles.withThumbnail]: shouldShowThumbnail,
        [styles.isExtra]: isExtra,
      })}
    >
      {shouldShowThumbnail && (
        <div className={styles.placeholder}>
          <Image url={imageUrl} label={label} width={64} height={64} />
        </div>
      )}
      {shouldShowIcon && !shouldShowThumbnail && <Icon label={label} />}
      {label}
    </Wrapper>
  );
};
